var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAcc2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 7,
    viewBox: "0 0 12 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.99995 0.0242181C6.13329 0.0242181 6.26262 0.0492187 6.38795 0.0992189C6.51328 0.149219 6.61728 0.215885 6.69995 0.299219L11.3 4.89922C11.4833 5.08255 11.575 5.31589 11.575 5.59922C11.575 5.88255 11.4833 6.11589 11.3 6.29922C11.1166 6.48255 10.8833 6.57422 10.6 6.57422C10.3166 6.57422 10.0833 6.48255 9.89995 6.29922L5.99995 2.39922L2.09995 6.29922C1.91662 6.48255 1.68328 6.57422 1.39995 6.57422C1.11662 6.57422 0.883286 6.48255 0.699952 6.29922C0.516619 6.11588 0.424951 5.88255 0.424951 5.59922C0.424951 5.31589 0.516619 5.08255 0.699952 4.89922L5.29995 0.299219C5.39995 0.199219 5.50829 0.128218 5.62495 0.0862183C5.74162 0.0442185 5.86662 0.0235514 5.99995 0.0242181Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAcc2);
export default __webpack_public_path__ + "static/media/acc2.a38981564dc45a7538e6b863af3a0db4.svg";
export { ForwardRef as ReactComponent };